import React from 'react';
import ConsultantDashboardPage from './ConsultantDashboardPage';

const EnterpriseDashboardPage: React.FC = () => {
  return <ConsultantDashboardPage scope="enterprise" />;
};

export default EnterpriseDashboardPage;

